<div class="bg-image" [style.background-color]="item.customField8">
  <div fxLayoutAlign="center center">

    <div class="fast title" [style.background-color]="item.customField26" contentAnim [aniName]="img.customField36">
      <h4 [style.font-size]="item.customField23" [ngStyle.lt-md]="{ 'font-size': item.customField24}"
        [innerHTML]="item.title"></h4>
    </div>
  </div>

  <div class="scroll-container" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="20px" fxLayoutAlign="center center">

    <div fxFlex="100" fxFlex.gt-sm="10">

    </div>
    <div class="iconType36" [style.background-color]="img.customField8" contentAnim [aniName]="img.customField36" *ngFor="let img of item.images; let i = index"
      fxFlex="100" fxFlex.gt-sm="25" fxLayoutGap="20px" [style.height]="img.customField10" [ngClass]="getScrollClass(i)" #stepElement>


      <a class="learn-more" (click)="openInNewWindow(img.customField7)" [style.background-color]="img.customField9" mat-raised-button
        color="primary">{{img.customField5}}</a>
      <h2 [style.font-size]="item.customField34" [ngStyle.lt-md]="{ 'font-size': item.customField35}">
        {{img.customField4}}</h2>




      <p [style.font-size]="item.customField39" [ngStyle.lt-md]="{ 'font-size': item.customField40}"
        style="display: flex;" [innerHTML]="img.customField16"></p>

      <div>
        <br>
      </div>

      <img [src]="serverPath1+img.customField6" class="icon" [alt]="img.altImage">


    </div>

    <div fxFlex="100" fxFlex.gt-sm="10">

    </div>

  </div>
</div>